function uppercase(value) {
    if (!value) return '';

    return  value.toString().toUpperCase();
}

function trim(value) {
  if (!value) return '';

  return  value.toString().trim();
}

export {uppercase, trim}
